import * as React from "react";
import { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { Dispatch } from "redux";
import { musicsAction } from "../../actions/musicsAction";
import {
	DABBackToList,
	DABButton,
	DABTextBox,
	LoadingSpinnerModal,
} from "../../components/dab";
import { getLoggedUserId } from "../../services/selectors/Accounts";
import { showAlert, showAlertWithBacktrack } from "../common/functions";
import uploadFileToBlob from "../../services/Azure/azureBlob";
import BinImg from "../../assets/images/bin-img.svg";
import MusicsService from "../../services/api/musicsService";

class Guid {
	static newGuid() {
		return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
			/[xy]/g,
			function (c) {
				var r = (Math.random() * 16) | 0,
					v = c == "x" ? r : (r & 0x3) | 0x8;
				return v.toString(16);
			}
		);
	}
}

interface MusicsProps {
	dispatch: Dispatch<any>;
	musicsData: any;
	callback: any;
	id: number;
}

const MusicsDetail: React.SFC<MusicsProps> = ({
	dispatch,
	musicsData,
	callback,
	id,
}) => {
	const history = useHistory();
	const [formSubmit, setFormSubmit] = useState(false);
	const [isBookMark, setIssBookMark] = useState(false);
	const [isReviewPage, setIsReviewPage] = useState(false);
	const [isErrorOnPage, setIsErrorOnPage] = useState(false);
	const [selectedImgFile, setImageFile] = useState<any>(null);
	const [uploadedUrl, setUploadedURL] = useState<any>(null);
	const [isDetailLoaded, setDetailLoaded] = useState(false);
	const [isDirty, setIsDirty] = useState<boolean>(false);
	const [trackName, setTrackName] = useState<any>(null);
	const [artistName, setArtistName] = useState<any>(null);
	const [albumName, setAlbumName] = useState<any>(null);
	const [orderNum, setOrderNum] = useState<any>(null);
	const [showModal, setShowModal] = useState(false);
	const [selectedFileName, setSelectedFileName] = useState("");
	const [linkError, setLinkError] = useState("");
	const [isEditCoverImgChange, setIsEditCoverImgChange] = useState(false);
	const [dropdownList, setDropdownList] = useState<any[]>([]);
	const [platforms, setPlatforms] = useState<any[]>([
		{ platform: "", link: "" },
	]);

	const handleChange = (index: number, field: any, value: string) => {
		const updated = [...platforms];
		updated[index][field] = value;
		setPlatforms(updated);
	};
	const handleAdd = () => {
		setPlatforms([...platforms, { platform: "", link: "" }]);
	};
	const handleRemove = (index: number) => {
		const updated = platforms.filter((_, i) => i !== index);
		setPlatforms(updated);
	};

	React.useEffect(() => {
		const frompath = sessionStorage.getItem("fromPath");
		if (frompath) {
			sessionStorage.removeItem("fromPath");
		}
		if (id !== 0) {
			dispatch(musicsAction.musicsGetDetail(id));
			setShowModal(true);
		}
		const fetchDropdown = async () => {
			const dropdownList = await MusicsService.musicPlatformList();
			setDropdownList(
				dropdownList?.streamingPlatformLists?.map((item) => item.platformName)
			);
		};
		fetchDropdown();
	}, [id, dispatch]);

	if (musicsData) {
		if (musicsData.isError && !musicsData.isSuccess) {
			if (showModal) {
				setShowModal(false);
			}
			musicsData.isError = false;
			if (musicsData.status === "Unauthorized") {
				sessionStorage.setItem(
					"fromPath",
					window.location.pathname + window.location.search
				);
				history.push("/401");
			} else {
				showAlertWithBacktrack(musicsData.status, true, history);
			}
			setIsErrorOnPage(false);
		}

		if (!musicsData.isError && musicsData.isSuccess) {
			if (showModal) {
				setShowModal(false);
			}
		}

		// GET DETAIL HANDLE
		if (musicsData.isDetailComplete) {
			if (!isDetailLoaded && musicsData.musicsInput?.musicAlbum) {
				if (musicsData.musicsInput?.musicAlbum !== null) {
					const fileName = musicsData.musicsInput?.musicAlbum?.coverImageUrl
						?.split("/")
						.pop();
					setSelectedFileName(fileName);
					setUploadedURL(musicsData.musicsInput?.musicAlbum?.coverImageUrl);
					setAlbumName(musicsData.musicsInput?.musicAlbum?.albumName);
					setArtistName(musicsData.musicsInput?.musicAlbum?.artistName);
					setTrackName(musicsData.musicsInput?.musicAlbum?.trackName);
					setOrderNum(musicsData.musicsInput?.musicAlbum?.sortOrder);
					setPlatforms(
						musicsData.musicsInput?.musicAlbum?.links.length > 0
							? musicsData.musicsInput?.musicAlbum?.links.map((item) => ({
									platform: item.key,
									link: item.url,
							  }))
							: [{ platform: "", link: "" }]
					);
					setDetailLoaded(true);
					musicsData.isSuccess = false;
					musicsData.status = null;
				}
			}
		}

		// EXECUTE AFTER SUCCESSFULL SUBMIT
		if (
			showModal &&
			formSubmit &&
			!musicsData.isFormSubmit &&
			musicsData.isSuccess
		) {
			if (musicsData.isSuccess) {
				if (showModal) {
					setShowModal(false);
				}
				window.localStorage.setItem("alertMessage", musicsData.status);
				window.location.href = "/music";
			}
		}
	}

	const validatePlatforms = () => {
		// At least one item must have both values
		return platforms.some(
			(item) => item.platform.trim() !== "" && item.link.trim() !== ""
		);
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		setLinkError("");

		if (!validatePlatforms()) {
			setLinkError("Please add at least one valid platform and link.");
			return;
		}

		setShowModal(true);
		sessionStorage.removeItem("createDABFilms");
		const filteredPlatforms = platforms
			.filter((p) => p.platform.trim() !== "" && p.link.trim() !== "")
			.map((p) => ({
				key: p.platform,
				url: p.link,
			}));
		const data = {
			...(id !== 0 && { AlbumId: id }),
			trackName: trackName,
			artistName: artistName,
			albumName: albumName,
			coverImageUrl: uploadedUrl,
			links: filteredPlatforms,
			sortOrder: orderNum ? parseInt(orderNum) : null,
			authorUserId: getLoggedUserId(),
		};

		if (isEditCoverImgChange) {
			const coverImageUrl = await uploadFileToBlob(
				selectedImgFile,
				Guid.newGuid(),
				"Image"
			);
			data.coverImageUrl = coverImageUrl;
		}
		setFormSubmit(true);
		dispatch(musicsAction.musicsSave(id, data));
	};

	React.useEffect(() => {
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem("SESSIONEXPIRY");
			const inSession = Date.now() < Number(sessionExpiry);
			if (!formSubmit && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) {
			window.addEventListener("beforeunload", eventHandler);
		}
		return () => {
			window.removeEventListener("beforeunload", eventHandler);
		};
	}, [isDirty && !formSubmit]);

	const handleCancel = (e) => {
		e.preventDefault();
		history.goBack();
	};

	const handleFileChange = (event) => {
		const extension = event.target.files[0].name.split(".").pop();
		if (extension === "png" || extension === "jpg" || extension === "jpeg") {
			handleFileUpload(event.target.files[0]);
		} else {
			event.target.value = null;
			showAlert(
				`Please select a valid image file (${["png", "jpg", "jpeg"].join(
					", "
				)} only).`,
				true
			);
		}
	};

	const handleFileUpload = async (file: any) => {
		setSelectedFileName(file.name);
		setIsEditCoverImgChange(true);
		setImageFile(file);
	};

	const getPlatformOptions = (currentIndex: number, dropdownList: string[]) => {
		const selected = new Set(
			platforms
				.map((p) => p.platform)
				.filter((_, i) => i !== currentIndex && !!platforms[i].platform)
		);

		return [
			...dropdownList
				.filter(
					(name) =>
						!selected.has(name) || name === platforms[currentIndex]?.platform
				)
				.map((name) => ({ value: name, text: name })),
		];
	};

	const truncate = (str: string, max: number) =>
		str.length > max ? str.substring(0, max) + "..." : str;

	return (
		<>
			<div className="musics-detail mb-5">
				{showModal && (
					<LoadingSpinnerModal isShowModal={showModal} modalChange={() => {}} />
				)}
				<div className="card-box m-0">
					{!isBookMark && !isReviewPage && !isDetailLoaded && id === 0 && (
						<form
							name="createform"
							onSubmit={handleSubmit}
							className="create-form"
						>
							<div className="row">
								<div className="col-6">
									<FormGroup>
										<Label
											htmlFor="albumName"
											className="col-form-label"
											data-testid="albumName"
										>
											Album Name
										</Label>
										<DABTextBox
											type="text"
											id="albumName"
											data-testid="albumName"
											isRequired={true}
											isHover={false}
											onChange={(event) => {
												const value = event.target.value;
												setAlbumName(value);
											}}
											value={albumName}
											pattern=".*\S.*"
											title="Input cannot be only spaces"
											maxLength={30}
										/>
										{albumName?.length >= 30 && (
											<span className="text-warning">
												Character limit met. Maximum 30 characters allowed
											</span>
										)}
									</FormGroup>
								</div>
							</div>
							<div className="row">
								<div className="col-6">
									<FormGroup data-testid="imageFileContainer">
										<Label
											data-testid="lblcoverimg"
											htmlFor="imageUpload"
											className="col-form-label"
										>
											Cover Image
										</Label>
										<Input
											type="file"
											name="coverFile"
											id="imgCover"
											required={selectedFileName === ""}
											accept="image/png, image/jpeg, image/jpg"
											onChange={(e) => {
												handleFileChange(e);
											}}
										/>
									</FormGroup>
									{selectedFileName && (
										<div className="mb-1 text-muted">
											Selected file: <strong>{selectedFileName}</strong>
										</div>
									)}
								</div>
							</div>
							<div className="row">
								<div className="col-6">
									<FormGroup>
										<Label
											htmlFor="trackName"
											className="col-form-label"
											data-testid="trackName"
										>
											Track Name
										</Label>
										<DABTextBox
											type="text"
											id="trackName"
											data-testid="trackName"
											isRequired={true}
											isHover={false}
											onChange={(event) => {
												setTrackName(event.target.value);
											}}
											value={trackName}
											pattern=".*\S.*"
											title="Input cannot be only spaces"
											maxLength={30}
										/>
										{trackName?.length >= 30 && (
											<span className="text-warning">
												Character limit met. Maximum 30 characters allowed
											</span>
										)}
									</FormGroup>
								</div>
							</div>
							<div className="row">
								<div className="col-6">
									<FormGroup>
										<Label
											htmlFor="artistName"
											className="col-form-label"
											data-testid="artistName"
										>
											Artist Name
										</Label>
										<DABTextBox
											type="text"
											id="artistName"
											data-testid="artistName"
											isRequired={true}
											isHover={false}
											onChange={(event) => {
												setArtistName(event.target.value);
											}}
											value={artistName}
											pattern=".*\S.*"
											title="Input cannot be only spaces"
											maxLength={30}
										/>
										{artistName?.length >= 30 && (
											<span className="text-warning">
												Character limit met. Maximum 30 characters allowed
											</span>
										)}
									</FormGroup>
								</div>
							</div>
							<div className="row">
								<div className="col-6">
									<FormGroup>
										<div className="d-flex gap-2 align-items-center">
											<Label
												htmlFor="orderno"
												className="col-form-label"
												data-testid="orderno"
											>
												Order No
											</Label>
											<span>
												(Note: The system will assign the next sequential order
												number if no value is entered.)
											</span>
										</div>
										<Input
											type="number"
											value={orderNum || ""}
											onChange={(e) => {
												const val = e.target.value;
												if (/^\d*$/.test(val)) {
													if (val.length <= 5) {
														setOrderNum(val);
													}
												}
											}}
											min="1"
											maxLength={5}
											className="no-spinner"
											onKeyDown={(e) => {
												if (["e", "E", "+", "-", "."].includes(e.key)) {
													e.preventDefault();
												}
											}}
										/>
									</FormGroup>
								</div>
							</div>
							<div>
								{platforms.map((item, index) => (
									<Row key={index} className="mb-3 align-items-center">
										<Col md={2}>
											<Input
												type="select"
												value={platforms[index].platform}
												onChange={(e) =>
													handleChange(index, "platform", e.target.value)
												}
												className="truncate-select"
											>
												<option hidden>
													Select Platform
												</option>
												{getPlatformOptions(index, dropdownList).map((opt) => (
													<option
														key={opt.value || `empty-${index}`}
														value={opt.value}
													>
														{opt.text}
													</option>
												))}
											</Input>
										</Col>

										<Col md={4}>
											<Input
												type="url"
												placeholder="Enter link"
												value={item.link}
												onChange={(e) =>
													handleChange(index, "link", e.target.value)
												}
											/>
										</Col>

										<Col md={2} className="d-flex justify-content-start gap-2">
											{platforms.length > 1 && (
												<Button
													style={{ background: "#FF274B1F", border: "none" }}
													onClick={() => handleRemove(index)}
													className="p-2"
												>
													<img
														src={BinImg}
														alt="Delete"
														className="d-flex"
														width={22}
														height={20}
													/>
												</Button>
											)}
											{index === platforms.length - 1 && (
												<Button
													type="button"
													color="secondary"
													style={{ background: "#555555", border: "none" }}
													className="p-2"
													onClick={handleAdd}
													disabled={platforms.length >= dropdownList.length}
												>
													Add Platform
												</Button>
											)}
										</Col>
									</Row>
								))}
								{linkError && (
									<span className="text-danger" data-testid="linkError">
										{linkError}
									</span>
								)}
							</div>

							<Row className="bd-buttons mt-4">
								<Col
									data-testid="cancelButtonContainer"
									className="d-flex justify-content-between"
								>
									<DABButton
										id="backToCreate"
										onClick={handleCancel}
										value="CANCEL"
									>
										CANCEL
									</DABButton>
									<DABButton
										id="submit"
										className="btn-submit-frm"
										data-testid="createButtonContainer"
										value="CREATE"
									>
										Create
									</DABButton>
								</Col>
								<Col data-testid="createButtonContainer"></Col>
							</Row>
						</form>
					)}
					{isDetailLoaded && !isBookMark && !isReviewPage && (
						<>
							<DABBackToList
								onClick={(e) => {
									history.goBack();
								}}
							/>
							<form
								name="createform"
								onSubmit={handleSubmit}
								className="create-form"
							>
								<div className="row">
									<div className="col-6">
										<FormGroup>
											<Label
												htmlFor="albumName"
												className="col-form-label"
												data-testid="albumName"
											>
												Album Name
											</Label>
											<DABTextBox
												type="text"
												id="albumName"
												data-testid="albumName"
												isRequired={true}
												isHover={false}
												onChange={(event) => {
													const value = event.target.value;
													setAlbumName(value);
												}}
												value={albumName}
												pattern=".*\S.*"
												title="Input cannot be only spaces"
												maxLength={30}
											/>
											{albumName?.length >= 30 && (
												<span className="text-warning">
													Character limit met. Maximum 30 characters allowed
												</span>
											)}
										</FormGroup>
									</div>
								</div>
								<div className="row">
									<div className="col-6" data-testid="imageFileContainer">
										<FormGroup>
											<Label htmlFor="imageUpload" className="col-form-label">
												Cover Image
											</Label>
											<Input
												type="file"
												name="coverFile"
												id="imgCover"
												required={selectedFileName === ""}
												accept="image/png, image/jpeg, image/jpg"
												onChange={(e) => {
													handleFileChange(e);
												}}
											/>
										</FormGroup>
										{selectedFileName && (
											<div className="mb-1 text-muted">
												Selected file: <strong>{selectedFileName}</strong>
											</div>
										)}
									</div>
								</div>
								<div className="row">
									<div className="col-6">
										<FormGroup>
											<Label
												htmlFor="trackName"
												className="col-form-label"
												data-testid="trackName"
											>
												Track Name
											</Label>
											<DABTextBox
												type="text"
												id="trackName"
												data-testid="trackName"
												isRequired={true}
												isHover={false}
												onChange={(event) => {
													setTrackName(event.target.value);
												}}
												value={trackName}
												pattern=".*\S.*"
												title="Input cannot be only spaces"
												maxLength={30}
											/>
											{trackName?.length >= 30 && (
												<span className="text-warning">
													Character limit met. Maximum 30 characters allowed
												</span>
											)}
										</FormGroup>
									</div>
								</div>
								<div className="row">
									<div className="col-6">
										<FormGroup>
											<Label
												htmlFor="artistName"
												className="col-form-label"
												data-testid="artistName"
											>
												Artist Name
											</Label>
											<DABTextBox
												type="text"
												id="artistName"
												data-testid="artistName"
												isRequired={true}
												isHover={false}
												onChange={(event) => {
													setArtistName(event.target.value);
												}}
												value={artistName}
												pattern=".*\S.*"
												title="Input cannot be only spaces"
												maxLength={30}
											/>
											{artistName?.length >= 30 && (
												<span className="text-warning">
													Character limit met. Maximum 30 characters allowed
												</span>
											)}
										</FormGroup>
									</div>
								</div>
								<div className="row">
									<div className="col-6">
										<FormGroup>
											<div className="d-flex gap-2 align-items-center">
												<Label
													htmlFor="orderno"
													className="col-form-label"
													data-testid="orderno"
												>
													Order No
												</Label>
												<span>
													(Note: The system will assign the next sequential
													order number if no value is entered.)
												</span>
											</div>
											<Input
												type="number"
												value={orderNum || ""}
												onChange={(e) => {
													const val = e.target.value;
													if (/^\d*$/.test(val)) {
														if (val.length <= 5) {
															setOrderNum(val);
														}
													}
												}}
												min="1"
												maxLength={5}
												className="no-spinner"
												onKeyDown={(e) => {
													if (["e", "E", "+", "-", "."].includes(e.key)) {
														e.preventDefault();
													}
												}}
											/>
										</FormGroup>
									</div>
								</div>
								<div>
									{platforms.map((item, index) => (
										<Row key={index} className="mb-3 align-items-center">
											<Col md={2}>
												<Input
													type="select"
													value={platforms[index].platform}
													onChange={(e) =>
														handleChange(index, "platform", e.target.value)
													}
													className="truncate-select"
												>
													<option hidden>
														Select Platform
													</option>
													{getPlatformOptions(index, dropdownList).map(
														(opt) => (
															<option
																key={opt.value || `empty-${index}`}
																value={opt.value}
															>
																{opt.text}
															</option>
														)
													)}
												</Input>
											</Col>

											<Col md={4}>
												<Input
													type="url"
													placeholder="Enter link"
													value={item.link}
													onChange={(e) =>
														handleChange(index, "link", e.target.value)
													}
												/>
											</Col>

											<Col
												md={2}
												className="d-flex justify-content-start gap-2"
											>
												{platforms.length > 1 && (
													<Button
														style={{ background: "#FF274B1F", border: "none" }}
														onClick={() => handleRemove(index)}
														className="p-2"
													>
														<img
															src={BinImg}
															alt="Delete"
															className="d-flex"
															width={22}
															height={20}
														/>
													</Button>
												)}
												{index === platforms.length - 1 && (
													<Button
														type="button"
														color="secondary"
														style={{ background: "#555555", border: "none" }}
														className="p-2"
														onClick={handleAdd}
														disabled={platforms.length >= dropdownList.length}
													>
														Add Platform
													</Button>
												)}
											</Col>
										</Row>
									))}
									{linkError && (
										<span className="text-danger" data-testid="linkError">
											{linkError}
										</span>
									)}
								</div>
								<Row className="bd-buttons mt-3">
									<Col lg="5" data-testid="cancelButtonContainer">
										<DABButton
											id="backToCreate"
											onClick={handleCancel}
											value="CANCEL"
										>
											CANCEL
										</DABButton>
									</Col>
									<Col lg="1" data-testid="saveButtonContainer">
										<DABButton
											id="submit"
											className="btn-submit-frm"
											value="SAVE"
										>
											Save
										</DABButton>
									</Col>
								</Row>
							</form>
						</>
					)}
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state: any) => {
	const { musicsData } = state;
	return {
		musicsData,
	};
};

export default connect(mapStateToProps)(MusicsDetail);
